import { render, staticRenderFns } from "./formVtag.vue?vue&type=template&id=59e99a48&scoped=true"
import script from "./formVtag.vue?vue&type=script&lang=js"
export * from "./formVtag.vue?vue&type=script&lang=js"
import style0 from "./formVtag.vue?vue&type=style&index=0&id=59e99a48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e99a48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/重构-快递前端-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59e99a48')) {
      api.createRecord('59e99a48', component.options)
    } else {
      api.reload('59e99a48', component.options)
    }
    module.hot.accept("./formVtag.vue?vue&type=template&id=59e99a48&scoped=true", function () {
      api.rerender('59e99a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fiscalDocuments/mdfe/components/form/steps/formVtag.vue"
export default component.exports